export enum MarketingType {
  EEGDirectMarketing = 'Geförderte Direktvermarktung',
  Other = 'Sonstige Direktvermarktung',
}
